import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';
import { STATUS_OPTIONS } from 'src/app/components/shared/shared-constants';

export const CONSTS = {
  HEADER: $localize`Add Device`,
  EDIT_HEADER: $localize`Edit Device`,
  ADD: $localize`Save`,
  CLEAR: $localize`Reset`,
  DRIVER_ID_TOOLTIP_TEXT: $localize`Driver ID used for GTS`,
  LABEL: {
    EMPLOYEE_ID: $localize`Employee/CR ID`,
    DRIVER_ID: $localize`Driver ID`,
    EMAIL: $localize`Email`,
    LAST_NAME: $localize`Last Name`,
    FIRST_NAME: $localize`First Name`,
    LOCATION: $localize`Location`,
    STATUS: $localize`Active`,
  },
  PLACEHOLDER: {
    EMPLOYEE_ID: $localize`Enter Employee/CR ID`,
    DRIVER_ID: $localize`Enter Driver ID`,
    EMAIL: $localize`Enter Email`,
    LAST_NAME: $localize`Enter Last Name`,
    FIRST_NAME: $localize`Enter First Name`,
  },
};

export const DEVICE_IDS = {
  ID: 'id',
  EMPLOYEE_ID: 'employeeId',
  DRIVER_ID: 'driverId',
  EMAIL: 'email',
  LAST_LOGGED_IN: 'lastLoggedIn',
  INSERT_TIME: 'insertTime',
  ADDED_BY: 'addedBy',
  OS: 'os',
  BUILD_VERSION: 'buildVersion',
  MODEL: 'model',
  ENABLED: 'enabled',
  LOCATION: 'locationCode',
  LAST_NAME: 'lastName',
  FIRST_NAME: 'firstName',
};

export const ENABLED_OPTIONS: IOption[] = [
  { label: STATUS_OPTIONS.ACTIVE, value: true },
  { label: STATUS_OPTIONS.DEACTIVATED, value: false },
];
